import React, { Component } from "react";
import PropTypes from "prop-types";
import Timeline from "@material-ui/icons/Timeline";
import withStyles from "@material-ui/core/styles/withStyles";
import { isEqual, map, sortBy } from "lodash";

import BreakEvenChart from "./BreakEvenChart.jsx";
import Checkbox from "@material-ui/core/Checkbox";
import ECCard from "components/EnergyCompany/Cards/ECCard.jsx";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import GridContainer from "components/Grid/GridContainer.jsx";
import InputLabel from "@material-ui/core/InputLabel";
import GridItem from "components/Grid/GridItem.jsx";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { getBreakEven } from "services/companies";

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";

const styles = theme => ({
  ...extendedFormsStyle,
  chartsWrapper: {
    display: "grid",
    gridTemplateColumns: "48% 48%",
    gridColumnGap: "25px",
    gridRowGap: "25px",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "100%",
    },
  },
  checkbox: {
    '& svg': {
      margin: 0,
    },
  },
  inputsWrapper: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridColumnGap: "25px",
  },
});

class BreakEven extends Component {
  constructor(props) {
    super(props);

    this.state = {
      distribuidoraSelect: props.distribuidoraSugeridaId,
      energiaIncentivadaSelecionada: true,
      precosPorAno: null,
      precosPorAnoI50: null,
    };
  }

  componentDidMount() {
    this.getBreakEvenHandler(this.props.distribuidoraSugeridaId);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.distribuidoraSugeridaId, this.props.distribuidoraSugeridaId)) {
      this.setState({ distribuidoraSelect: this.props.distribuidoraSugeridaId });
      this.getBreakEvenHandler(this.props.distribuidoraSugeridaId);
    }
  }

  getBreakEvenHandler(id) {
    getBreakEven(id, this.props.companyId).then(({ data }) => {
      this.setState({
        precosPorAno: data.precosPorAno,
        precosPorAnoI50: data.precosPorAnoI50,
      });
    });
  }

  handleSelectDistribuidora = event => {
    this.setState({ distribuidoraSelect: event.target.value });
    this.getBreakEvenHandler(event.target.value);
  };

  render() {
    const { agentesDistribuidores, classes } = this.props;
    const { precosPorAno, precosPorAnoI50, energiaIncentivadaSelecionada } = this.state;
    const precosSelecionado = energiaIncentivadaSelecionada ? precosPorAnoI50 : precosPorAno;

    if (!precosSelecionado) return null;

    return (
      <GridContainer>
        <GridItem md={12} sm={12} xs={12}>
          <ECCard
            actions={
              <FormControlLabel
                control={
                  <Checkbox
                    checked={energiaIncentivadaSelecionada}
                    className={classes.checkbox}
                    onChange={e => this.setState({ energiaIncentivadaSelecionada: e.target.checked })}
                  />
                }
                label="Incentivada 50%"
              />
            }
            content={
              <div>
                <div className={classes.inputsWrapper}>
                  <FormControl className={classes.selectFormControl} fullWidth>
                    <InputLabel className={classes.selectLabel} htmlFor="distribuidora-select">
                      Distribuidora
                    </InputLabel>
                    <Select
                      classes={{ select: classes.select }}
                      inputProps={{ id: "distribuidora-select" }}
                      MenuProps={{ className: classes.selectMenu }}
                      onChange={this.handleSelectDistribuidora}
                      value={this.state.distribuidoraSelect}
                    >
                      <MenuItem classes={{ root: classes.selectMenuItem }} disabled>
                        Distribuidora
                      </MenuItem>
                      {map(sortBy(agentesDistribuidores, ["nome"]), distribuidora => (
                        <MenuItem
                          classes={{ root: classes.selectMenuItem, selected: classes.selectMenuItemSelected }}
                          key={distribuidora.id}
                          value={distribuidora.id}
                        >
                          {distribuidora.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
                <div className={classes.chartsWrapper}>
                  {map(precosSelecionado, (value, key) => (
                    <BreakEvenChart
                      ano={key}
                      data={value}
                      key={key}
                    />
                  ))}
                </div>
              </div>
            }
            icon={<Timeline />}
            title="Break Even"
          />
        </GridItem>
      </GridContainer>
    );
  }
};

BreakEven.propTypes = {
  agentesDistribuidores: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    nome: PropTypes.string.isRequired,
  })).isRequired,
  classes: PropTypes.object.isRequired,
  companyId: PropTypes.string.isRequired,
  distribuidoraSugeridaId: PropTypes.string.isRequired,
};

export default withStyles(styles)(BreakEven);



// WEBPACK FOOTER //
// ./src/views/Dashboard/partials/BreakEven.jsx